type LoliEmotion = "cry" | "smile";

export class LoliManager {
  public emotion: LoliEmotion = "cry";
}
